import {isServer} from '@tanstack/react-query';
import {api as apiClient} from './baseApi.client';
import {api as apiServer} from './baseApi.server';

export const api = async () => {
  return isServer ? await apiServer() : apiClient;
};
